import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./header.css"

const BANNER_KEY = "nwd_feedback_banner_dismissed";
const DISMISS_DURATION_MS = 30 * 24 * 60 * 60 * 1000;
const TALLY_FEEDBACK_URL = "https://form.typeform.com/to/Jkdxz3gI";

export default function FeedbackBanner() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.userLogin);

  useEffect(() => {
    if (!userInfo) {
      setVisible(false);
      return;
    }
    const dismissed = localStorage.getItem(BANNER_KEY);
    if (!dismissed) {
      setVisible(true);
      return;
    }
    const dismissedAt = parseInt(dismissed, 10);
    if (Date.now() - dismissedAt > DISMISS_DURATION_MS) {
      localStorage.removeItem(BANNER_KEY);
      setVisible(true);
    }
  }, [userInfo, location.pathname]);

  const openSurvey = () => {
    window.open(TALLY_FEEDBACK_URL, "_blank", "noopener,noreferrer");
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    localStorage.setItem(BANNER_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="feedback-banner" onClick={openSurvey}>
      <span className="feedback-banner__text">
        Used NWD for 10+ days? Share your feedback —
        <strong> get a £10 voucher.</strong>
      </span>
      <button
        className="feedback-banner__cta"
        onClick={(e) => {
          e.stopPropagation();
          openSurvey();
        }}
      >
        Share feedback
      </button>
      <button
        className="feedback-banner__close"
        onClick={handleDismiss}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  );
}
